var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"elevator-3d"},[_c('div',{staticClass:"elevator-svg-container"},[_c('div',{staticClass:"map-container",attrs:{"id":"tencent-map-container"}})])])
}]

export { render, staticRenderFns }